import { makeAutoObservable } from "mobx";
import { onError } from "@/utils/onError";
export class SingleBaseStore {
    constructor(baseService) {
        this.baseService = baseService;
        this.base = null;
        this.loading = true;
        makeAutoObservable(this);
    }
    setBase(base) {
        this.base = base;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    async init(baseId) {
        this.setLoading(true);
        try {
            const bases = baseId
                ? await this.baseService.getBasesByIds([baseId])
                : null;
            this.setBase(bases?.[0] || null);
        }
        catch (error) {
            onError(error, "Error initializing base");
        }
        finally {
            this.setLoading(false);
        }
    }
    async saveBase(baseData) {
        try {
            this.setLoading(true);
            const task = this.base
                ? this.baseService.updateBase(this.base.id, baseData)
                : this.baseService.createBase(baseData);
            this.setBase(await task);
            return this.base;
        }
        catch (error) {
            onError(error, "Error saving base");
            return null;
        }
        finally {
            this.setLoading(false);
        }
    }
    async deleteBase(baseId) {
        this.setLoading(true);
        try {
            await this.baseService.deleteBase(baseId);
            this.setBase(null);
        }
        catch (error) {
            onError(error, "Failed to delete base");
        }
        finally {
            this.setLoading(false);
        }
    }
    clearBaseData() {
        this.setBase(null);
        this.setLoading(false);
    }
}
